import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { firstValueFrom, tap } from 'rxjs';
import { LocalStorageService } from '../storage/local-storage.service';
import { ClientBaseApi } from '../api/clientBase.api';

export interface BaseConfig {
  gatewayUrl: string;
  apiUrl: string;
  [key: string]: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService extends ClientBaseApi {
  private readonly localStorage = inject(LocalStorageService);
  private readonly config: WritableSignal<BaseConfig | null> = signal(null);
  public setConfig(config: BaseConfig) {
    this.config.set(config);
    Object.entries(config).forEach(([key, value]) => {
      this.localStorage.setItem(key, value);
    });
  }

  public getConfig(key: keyof BaseConfig) {
    const config = this.config();
    if (!config) {
      return undefined;
    }
    return config[key];
  }
}
